import React from 'react';
import { ArrowLeft, Mail, Globe, ExternalLink } from 'lucide-react';
export function PrivacyPolicyPage() {
  return <div className="min-h-screen bg-white text-slate-900 font-sans" data-id="element-356">
      {/* Navigation Bar */}
      <nav className="sticky top-0 z-10 w-full bg-white/80 backdrop-blur-md border-b border-slate-100" data-id="element-357">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 h-16 flex items-center" data-id="element-358">
          <a href="/" className="group flex items-center text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-359">
            <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-360" />
            Volver al inicio
          </a>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-12 sm:py-16" data-id="element-361">
        <article className="prose prose-slate max-w-none" data-id="element-362">
          {/* Header */}
          <header className="mb-12 border-b border-slate-200 pb-8" data-id="element-363">
            <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight mb-4" data-id="element-364">
              Política de privacidad AEDE
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-365">
              Asociación Ecuatoriana de Deportes Electrónicos
            </p>
          </header>

          {/* Section 1 */}
          <section className="mb-12" data-id="element-366">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center" data-id="element-367">
              <span className="bg-slate-100 text-slate-500 text-sm font-mono py-1 px-2 rounded mr-3" data-id="element-368">
                1
              </span>
              AVISO LEGAL
            </h2>

            <div className="space-y-8 pl-0 sm:pl-4 border-l-2 border-slate-100" data-id="element-369">
              <div className="pl-4 sm:pl-6" data-id="element-370">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-371">
                  1.1 Propósito del sitio web y su APP
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-372">
                  Este portal y su APP constituye parte de la plataforma digital
                  oficial de la Asociación Ecuatoriana de Deportes Electrónicos
                  (AEDE), entidad encargada de regular y promover los esports en
                  Ecuador. La navegación y uso de este sitio o de su APP implica
                  la aceptación plena de los términos aquí establecidos.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-373">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-374">
                  1.2 Propiedad intelectual
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-375">
                  Todos los contenidos publicados en este sitio web y su APP,
                  incluyendo textos, imágenes, logotipos, diseños y material
                  audiovisual, son propiedad exclusiva de AEDE o se utilizan
                  bajo licencias debidamente autorizadas. Queda estrictamente
                  prohibida su reproducción, modificación o distribución sin
                  autorización previa por escrito.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-376">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-377">
                  1.3 Exactitud de la información
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-378">
                  AEDE se esfuerza por mantener información actualizada y veraz,
                  pero no garantiza la ausencia total de errores u omisiones.
                  Los usuarios deben verificar la vigencia de los contenidos,
                  especialmente en lo relacionado con calendarios de eventos,
                  reglamentos y procesos competitivos.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-379">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-380">
                  1.4 Enlaces externos
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-381">
                  El sitio y su APP pueden contener vínculos a páginas de
                  terceros relacionados con el ecosistema esports. AEDE no asume
                  responsabilidad por el contenido, políticas de privacidad o
                  prácticas de estos sitios externos, cuyo acceso es bajo
                  responsabilidad exclusiva del usuario.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-382">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-383">
                  1.5 Condiciones de acceso
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-384">
                  El uso básico del sitio web y su APP es gratuito, pero ciertas
                  funcionalidades como inscripciones a torneos, solicitud de
                  licencias o acceso a áreas exclusivas requieren registro
                  previo y aceptación de condiciones específicas. Los usuarios
                  son responsables de proporcionar información veraz y mantener
                  sus credenciales de acceso seguras.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-385">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-386">
                  1.6 Marco legal aplicable
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-387">
                  Este sitio web, su APP y todas sus actividades se rigen por
                  las leyes de la República del Ecuador. Cualquier controversia
                  relacionada con su uso será resuelta en los tribunales
                  competentes de acuerdo con la legislación ecuatoriana vigente.
                </p>
              </div>
            </div>
          </section>

          {/* Section 2 */}
          <section className="mb-12" data-id="element-388">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center" data-id="element-389">
              <span className="bg-slate-100 text-slate-500 text-sm font-mono py-1 px-2 rounded mr-3" data-id="element-390">
                2
              </span>
              RECOPILACIÓN DE DATOS PERSONALES
            </h2>

            <div className="mb-6 text-slate-600 leading-relaxed" data-id="element-391">
              <p data-id="element-392">
                En la Asociación Ecuatoriana de Deportes Electrónicos (AEDE),
                valoramos la privacidad de nuestros miembros y participantes.
                Recopilamos información personal únicamente cuando es necesaria
                para nuestras actividades como entidad reguladora de esports en
                Ecuador, siempre con el consentimiento previo y expreso del
                titular.
              </p>
            </div>

            <div className="space-y-8 pl-0 sm:pl-4 border-l-2 border-slate-100" data-id="element-393">
              <div className="pl-4 sm:pl-6" data-id="element-394">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-395">
                  2.1 Tipos de datos recopilados
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-396">
                  Para garantizar el correcto desarrollo de nuestras
                  competencias y servicios, requerimos información básica como
                  nombre completo, documento de identidad, datos de contacto y
                  en el caso de torneos presenciales, certificados médicos
                  vigentes. Los deportistas deben proporcionar adicionalmente su
                  historial competitivo y, cuando corresponda, autorizaciones
                  para menores de edad.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-397">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-398">
                  2.2 Métodos de recolección
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-399">
                  La información es proporcionada directamente por los usuarios
                  a través de nuestros formularios digitales seguros durante
                  procesos de registro, licenciamiento o inscripción a eventos.
                  Utilizamos sistemas con cifrado para garantizar la protección
                  de los datos durante su transmisión y almacenamiento.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-400">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-401">
                  2.3 Finalidad del tratamiento
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-402">
                  Los datos personales son utilizados exclusivamente para
                  gestionar participaciones en torneos, emitir licencias
                  oficiales, mantener actualizado el Data Center, mantener
                  comunicaciones institucionales y cumplir con obligaciones
                  legales como entidad deportiva. En ningún caso utilizamos esta
                  información para fines distintos a los aquí establecidos.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-403">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-404">
                  2.4 Consentimiento y transparencia
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-405">
                  Toda recolección de datos se realiza previa aceptación expresa
                  de nuestra política de privacidad. Los usuarios pueden
                  consultar en cualquier momento qué información tenemos
                  almacenada, solicitar su corrección o eliminación.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-406">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-407">
                  2.5 Protección de datos sensibles
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-408">
                  AEDE no solicita ni almacena información considerada sensible
                  según la legislación ecuatoriana, excepto cuando sea
                  estrictamente necesario para el cumplimiento de normativas
                  deportivas internacionales y siempre con autorización
                  explícita del titular.
                </p>
                <div className="mt-4 p-4 bg-slate-50 rounded-lg border border-slate-100" data-id="element-409">
                  <p className="text-sm text-slate-600 flex items-start" data-id="element-410">
                    <Mail className="w-4 h-4 text-slate-400 mr-2 mt-1 flex-shrink-0" data-id="element-411" />
                    <span data-id="element-412">
                      Para ejercer cualquier derecho sobre sus datos personales
                      o resolver inquietudes sobre su tratamiento, los usuarios
                      pueden contactarnos a través del correo electrónico{' '}
                      <a href="mailto:oficial@aede.ec" className="text-blue-600 hover:text-blue-800 font-medium underline decoration-blue-200 hover:decoration-blue-800 transition-all" data-id="element-413">
                        oficial@aede.ec
                      </a>
                      , donde atenderemos sus solicitudes.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Section 3 */}
          <section className="mb-12" data-id="element-414">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center" data-id="element-415">
              <span className="bg-slate-100 text-slate-500 text-sm font-mono py-1 px-2 rounded mr-3" data-id="element-416">
                3
              </span>
              USO DE LA INFORMACIÓN RECOPILADA
            </h2>

            <div className="mb-6 text-slate-600 leading-relaxed" data-id="element-417">
              <p data-id="element-418">
                En la Asociación Ecuatoriana de Deportes Electrónicos (AEDE),
                utilizamos la información personal de nuestros usuarios
                únicamente para los fines establecidos, asegurando siempre el
                manejo ético y responsable de los datos bajo los más altos
                estándares de protección.
              </p>
            </div>

            <div className="space-y-8 pl-0 sm:pl-4 border-l-2 border-slate-100" data-id="element-419">
              <div className="pl-4 sm:pl-6" data-id="element-420">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-421">
                  3.1 Procesamiento de inscripciones a torneos
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-422">
                  La información proporcionada durante el registro es utilizada
                  para gestionar la participación en competencias oficiales
                  organizadas por AEDE. Estos datos nos permiten verificar la
                  identidad de los participantes, confirmar su elegibilidad
                  según los requisitos de cada torneo y realizar la debida
                  asignación a las diferentes categorías competitivas,
                  garantizando así el correcto desarrollo de los eventos.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-423">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-424">
                  3.2 Comunicaciones institucionales
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-425">
                  Los datos de contacto de nuestros usuarios son empleados
                  exclusivamente para enviar información relevante sobre
                  actividades, cambios en programación, resultados deportivos y
                  actualizaciones regulatorias relacionadas con el ecosistema de
                  esports en Ecuador. Todas las comunicaciones son realizadas
                  directamente por AEDE a través de canales oficiales.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-426">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-427">
                  3.3 Mejora continua de servicios
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-428">
                  Mediante el análisis de datos técnicos no identificables,
                  trabajamos en la optimización constante de nuestra plataforma
                  digital. Este proceso nos permite mejorar la experiencia de
                  usuario, corregir posibles fallas técnicas y desarrollar
                  nuevas funcionalidades que beneficien a toda la comunidad
                  esports asociada.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-429">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-430">
                  3.4 Limitaciones y garantías
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-431">
                  AEDE se compromete a utilizar la información recopilada
                  estrictamente para los fines aquí descritos. Los datos
                  personales no son compartidos con terceros no autorizados,
                  excepto cuando exista un requerimiento legal explícito o sea
                  necesario para el cumplimiento de normativas deportivas
                  internacionales aplicables. Toda información se maneja con
                  protocolos de seguridad avanzados y se conserva únicamente
                  durante el tiempo necesario para cumplir con las finalidades
                  establecidas.
                </p>
                <div className="mt-4 p-4 bg-slate-50 rounded-lg border border-slate-100" data-id="element-432">
                  <p className="text-sm text-slate-600 flex items-start" data-id="element-433">
                    <Mail className="w-4 h-4 text-slate-400 mr-2 mt-1 flex-shrink-0" data-id="element-434" />
                    <span data-id="element-435">
                      Para cualquier consulta sobre el tratamiento de datos
                      personales, los usuarios pueden contactarnos a través del
                      correo electrónico{' '}
                      <a href="mailto:oficial@aede.ec" className="text-blue-600 hover:text-blue-800 font-medium underline decoration-blue-200 hover:decoration-blue-800 transition-all" data-id="element-436">
                        oficial@aede.ec
                      </a>
                      , donde recibirán atención personalizada.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Section 4 */}
          <section className="mb-12" data-id="element-437">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center" data-id="element-438">
              <span className="bg-slate-100 text-slate-500 text-sm font-mono py-1 px-2 rounded mr-3" data-id="element-439">
                4
              </span>
              DERECHOS DE LOS USUARIOS
            </h2>

            <div className="mb-6 text-slate-600 leading-relaxed" data-id="element-440">
              <p data-id="element-441">
                En la Asociación Ecuatoriana de Deportes Electrónicos (AEDE),
                garantizamos el pleno ejercicio de los derechos de protección de
                datos personales de nuestros miembros y participantes, en
                cumplimiento de la Ley Orgánica de Protección de Datos
                Personales del Ecuador.
              </p>
            </div>

            <div className="space-y-8 pl-0 sm:pl-4 border-l-2 border-slate-100" data-id="element-442">
              <div className="pl-4 sm:pl-6" data-id="element-443">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-444">
                  4.1 Revocación del consentimiento
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-445">
                  Todo usuario puede revocar el consentimiento previamente
                  otorgado para el tratamiento de sus datos personales,
                  solicitando la interrupción de su uso para fines específicos
                  como comunicaciones institucionales o participación en
                  eventos. Esta revocación no tendrá efecto retroactivo y no
                  aplicará cuando el tratamiento sea necesario para el
                  cumplimiento de obligaciones legales o contractuales.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-446">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-447">
                  4.2 Procedimiento para ejercer derechos
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-448">
                  Para ejercer cualquiera de estos derechos, los usuarios deben
                  enviar una solicitud formal al correo electrónico{' '}
                  <a href="mailto:oficial@aede.ec" className="text-blue-600 hover:text-blue-800 font-medium underline decoration-blue-200 hover:decoration-blue-800 transition-all" data-id="element-449">
                    oficial@aede.ec
                  </a>
                  , indicando claramente el derecho que desean ejercer y
                  adjuntando los documentos que acrediten su identidad. AEDE
                  dará respuesta a todas las solicitudes dentro de un plazo
                  máximo de 10 días hábiles, contados desde la recepción de la
                  petición completa.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-450">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-451">
                  4.3 No discriminación
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-452">
                  AEDE garantiza que el ejercicio de estos derechos no generará
                  ningún tipo de trato discriminatorio o perjuicio para los
                  usuarios. Todas las solicitudes serán atendidas con estricto
                  respeto a los principios de confidencialidad y protección de
                  datos personales.
                </p>
              </div>
            </div>
          </section>

          {/* Section 5 */}
          <section className="mb-12" data-id="element-453">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center" data-id="element-454">
              <span className="bg-slate-100 text-slate-500 text-sm font-mono py-1 px-2 rounded mr-3" data-id="element-455">
                5
              </span>
              COMPARTICIÓN DE INFORMACIÓN CON TERCEROS
            </h2>

            <div className="mb-6 text-slate-600 leading-relaxed" data-id="element-456">
              <p data-id="element-457">
                En la Asociación Ecuatoriana de Deportes Electrónicos (AEDE),
                protegemos rigurosamente los datos personales de nuestros
                miembros y participantes. La información solo se comparte en las
                siguientes situaciones específicas y debidamente justificadas:
              </p>
            </div>

            <div className="space-y-8 pl-0 sm:pl-4 border-l-2 border-slate-100" data-id="element-458">
              <div className="pl-4 sm:pl-6" data-id="element-459">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-460">
                  5.1 Federaciones y organizaciones deportivas
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-461">
                  Los datos necesarios para validar participaciones en
                  competencias oficiales podrán ser compartidos con federaciones
                  deportivas nacionales e internacionales vinculadas a AEDE.
                  Este intercambio se limita exclusivamente a información
                  requerida para verificar licencias, rankings y cumplimiento de
                  reglamentos deportivos.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-462">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-463">
                  5.2 Proveedores autorizados
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-464">
                  AEDE trabaja con proveedores tecnológicos especializados en
                  gestión de eventos esports, quienes reciben únicamente la
                  información estrictamente necesaria para prestar sus
                  servicios. Estos terceros están contractualmente obligados a
                  mantener confidencialidad y aplicar medidas de seguridad
                  equivalentes a las nuestras, bajo supervisión constante.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-465">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-466">
                  5.3 Cumplimiento normativo
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-467">
                  Cuando exista un requerimiento formal de autoridades
                  ecuatorianas competentes o sea necesario para investigaciones
                  relacionadas con integridad deportiva, AEDE podrá compartir
                  información personal en el marco estricto de lo solicitado y
                  previa validación legal.
                </p>
              </div>
            </div>
          </section>

          {/* Section 6 */}
          <section className="mb-12" data-id="element-468">
            <h2 className="text-2xl font-bold text-slate-900 mb-6 flex items-center" data-id="element-469">
              <span className="bg-slate-100 text-slate-500 text-sm font-mono py-1 px-2 rounded mr-3" data-id="element-470">
                6
              </span>
              ACTUALIZACIONES DE LA POLÍTICA - AEDE
            </h2>

            <div className="mb-6 text-slate-600 leading-relaxed" data-id="element-471">
              <p className="mb-4" data-id="element-472">
                La Asociación Ecuatoriana de Deportes Electrónicos (AEDE) podrá
                modificar esta Política de Privacidad para mantenerla
                actualizada conforme a:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-slate-700" data-id="element-473">
                <li data-id="element-474">Nuevos requerimientos legales o regulatorios</li>
                <li data-id="element-475">Cambios en nuestros procesos operativos</li>
                <li data-id="element-476">Mejoras en los estándares de protección de datos</li>
              </ul>
            </div>

            <div className="space-y-8 pl-0 sm:pl-4 border-l-2 border-slate-100" data-id="element-477">
              <div className="pl-4 sm:pl-6" data-id="element-478">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-479">
                  6.1 Implementación de actualizaciones
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-480">
                  Las revisiones a esta política se realizarán cuando sea
                  necesario, garantizando que siempre refleje nuestras prácticas
                  actuales en el manejo de datos personales. Cada versión
                  incluirá fecha de vigencia clara y registro de cambios
                  sustanciales.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-481">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-482">
                  6.2 Comunicación de modificaciones
                </h3>
                <p className="text-slate-600 leading-relaxed mb-4" data-id="element-483">
                  Los usuarios serán notificados sobre cambios significativos
                  mediante:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 text-slate-700" data-id="element-484">
                  <li data-id="element-485">
                    Aviso destacado en el portal web oficial (
                    <a href="https://www.aede.ec" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline" data-id="element-486">
                      www.aede.ec
                    </a>
                    ) durante 15 días continuos
                  </li>
                  <li data-id="element-487">
                    Publicación en nuestras redes sociales verificadas
                    (@aedeecuador)
                  </li>
                </ul>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-488">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-489">
                  6.3 Vigencia de los cambios
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-490">
                  Las modificaciones entrarán en efecto a partir de la fecha
                  indicada en cada actualización, permitiendo un período mínimo
                  de 20 días para que los usuarios puedan revisar los nuevos
                  términos antes de su aplicación obligatoria.
                </p>
              </div>

              <div className="pl-4 sm:pl-6" data-id="element-491">
                <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-492">
                  6.4 Derechos de los usuarios ante actualizaciones
                </h3>
                <p className="text-slate-600 leading-relaxed mb-4" data-id="element-493">
                  Si los cambios afectan sustancialmente el tratamiento de datos
                  personales, los usuarios podrán:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4 text-slate-700" data-id="element-494">
                  <li data-id="element-495">
                    Aceptar los nuevos términos para continuar utilizando
                    nuestros servicios
                  </li>
                  <li data-id="element-496">
                    Solicitar la baja del sistema y eliminación de sus datos
                    personales
                  </li>
                  <li data-id="element-497">
                    Presentar consultas específicas a{' '}
                    <a href="mailto:oficial@aede.ec" className="text-blue-600 hover:underline" data-id="element-498">
                      oficial@aede.ec
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </section>

          {/* Footer Note */}
          <footer className="mt-16 pt-8 border-t border-slate-200 text-center" data-id="element-499">
            <p className="text-slate-500 text-sm mb-6" data-id="element-500">
              Se recomienda revisar periódicamente esta sección para mantenerse
              informado sobre nuestras prácticas de privacidad. La versión
              vigente siempre estará disponible en el apartado "Políticas" de
              nuestro sitio web oficial.
            </p>

            <div className="flex flex-col sm:flex-row justify-center items-center gap-6 text-sm text-slate-600" data-id="element-501">
              <a href="mailto:oficial@aede.ec" className="flex items-center hover:text-blue-600 transition-colors" data-id="element-502">
                <Mail className="w-4 h-4 mr-2" data-id="element-503" />
                oficial@aede.ec
              </a>
              <a href="https://www.aede.ec" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-blue-600 transition-colors" data-id="element-504">
                <Globe className="w-4 h-4 mr-2" data-id="element-505" />
                www.aede.ec
              </a>
              <a href="https://instagram.com/aedeecuador" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-blue-600 transition-colors" data-id="element-506">
                <ExternalLink className="w-4 h-4 mr-2" data-id="element-507" />
                @aedeecuador
              </a>
            </div>
          </footer>
        </article>
      </main>
    </div>;
}